import React, { useState } from "react";

// The ⓘ next to a system setting: what it does, its unit and default.
// Hover to peek, click to keep it open.

const show = (v) =>
  v === null || v === undefined
    ? "empty"
    : typeof v === "object"
      ? JSON.stringify(v)
      : String(v);

const ConfigInfo = ({ config }) => {
  const [pinned, setPinned] = useState(false);
  return (
    <span className="relative inline-block group align-middle">
      <button
        type="button"
        onClick={() => setPinned((p) => !p)}
        aria-label={`What is ${config.key}?`}
        className={`w-4 h-4 ml-1 rounded-full text-[10px] font-bold leading-4 text-center border ${
          config.inUse === false
            ? "border-gray-300 text-gray-400"
            : "border-blue-400 text-blue-600 hover:bg-blue-50"
        }`}
      >
        i
      </button>
      <span
        className={`${
          pinned ? "block" : "hidden group-hover:block"
        } absolute z-30 left-6 top-0 w-80 p-3 rounded-lg border bg-white shadow-lg text-left font-sans text-xs text-gray-700 whitespace-normal`}
      >
        <span className="block font-semibold text-gray-900 mb-1">
          {config.area ? `${config.area} · ` : ""}
          {config.key}
        </span>
        <span className="block leading-relaxed">
          {config.description || "No description yet."}
        </span>
        {(config.unit || config.defaultValue !== undefined) && (
          <span className="block mt-2 text-gray-500">
            {config.unit && <>Unit: {config.unit}</>}
            {config.unit && config.inUse !== false && " · "}
            {config.inUse !== false && <>Default: {show(config.defaultValue)}</>}
          </span>
        )}
      </span>
    </span>
  );
};

export default ConfigInfo;
